__turbopack_context__.v({
  "actionArrow": "overview-module__3vt5QG__actionArrow",
  "actionCard": "overview-module__3vt5QG__actionCard",
  "actionContent": "overview-module__3vt5QG__actionContent",
  "actionDescription": "overview-module__3vt5QG__actionDescription",
  "actionIcon": "overview-module__3vt5QG__actionIcon",
  "actionTitle": "overview-module__3vt5QG__actionTitle",
  "actionsGrid": "overview-module__3vt5QG__actionsGrid",
  "activityBadge": "overview-module__3vt5QG__activityBadge",
  "activityCard": "overview-module__3vt5QG__activityCard",
  "activityContent": "overview-module__3vt5QG__activityContent",
  "activityIcon": "overview-module__3vt5QG__activityIcon",
  "activityItem": "overview-module__3vt5QG__activityItem",
  "activityList": "overview-module__3vt5QG__activityList",
  "activityTime": "overview-module__3vt5QG__activityTime",
  "activityTitle": "overview-module__3vt5QG__activityTitle",
  "container": "overview-module__3vt5QG__container",
  "emptyState": "overview-module__3vt5QG__emptyState",
  "header": "overview-module__3vt5QG__header",
  "section": "overview-module__3vt5QG__section",
  "sectionTitle": "overview-module__3vt5QG__sectionTitle",
  "statCard": "overview-module__3vt5QG__statCard",
  "statContent": "overview-module__3vt5QG__statContent",
  "statIcon": "overview-module__3vt5QG__statIcon",
  "statLabel": "overview-module__3vt5QG__statLabel",
  "statValue": "overview-module__3vt5QG__statValue",
  "statsGrid": "overview-module__3vt5QG__statsGrid",
  "subtitle": "overview-module__3vt5QG__subtitle",
  "title": "overview-module__3vt5QG__title",
});
